/**
 * Cross-sell Recommendations
 * Fetches complementary products from Shopify Recommendations API (Search & Discovery)
 * and renders product cards with add-to-cart functionality.
 * Supports pagination with arrow navigation.
 */
(function () {
  'use strict';

  document.querySelectorAll('.cross-sell-custom').forEach(function (container) {
    var productId = container.dataset.productId;
    var limit = parseInt(container.dataset.limit, 10) || 2;
    var showVariants = container.dataset.showVariants === 'true';
    var showComparePrice = container.dataset.showComparePrice === 'true';
    var buttonText = container.dataset.buttonText || '+ Ajouter';
    var buttonColor = container.dataset.buttonColor || '#4a0000';
    var textAdded = container.dataset.textAdded || '✓ Ajouté';
    var textError = container.dataset.textError || 'Erreur';
    var carousel = container.querySelector('[data-cross-sell-carousel]');

    if (!productId || !carousel) return;

    var allProducts = [];
    var currentPage = 0;

    function formatPrice(cents) {
      var euros = (cents / 100).toFixed(2).replace('.', ',');
      return euros + '€';
    }

    function buildCard(product) {
      var variant = product.variants[0];
      var image = product.featured_image || (product.images && product.images[0]) || '';
      var hasDiscount =
        showComparePrice &&
        variant.compare_at_price &&
        variant.compare_at_price > variant.price;

      var variantHTML = '';
      if (showVariants && product.variants.length > 1) {
        variantHTML =
          '<select class="cross-sell-custom__card-variant" data-cross-sell-variant>' +
          product.variants
            .map(function (v) {
              return (
                '<option value="' + v.id + '" data-price="' + v.price + '"' +
                (v.compare_at_price ? ' data-compare="' + v.compare_at_price + '"' : '') +
                '>' + v.title + '</option>'
              );
            })
            .join('') +
          '</select>';
      }

      var pricesHTML =
        '<span class="cross-sell-custom__price">' + formatPrice(variant.price) + '</span>' +
        (hasDiscount
          ? '<span class="cross-sell-custom__compare-price">' +
            formatPrice(variant.compare_at_price) +
            '</span>'
          : '');

      // Variant + Price on same line inside card-meta
      var metaHTML = '<div class="cross-sell-custom__card-meta">' +
        variantHTML +
        '<div class="cross-sell-custom__card-prices">' + pricesHTML + '</div>' +
        '</div>';

      var imageUrl = typeof image === 'string' ? image : '';
      if (imageUrl && imageUrl.indexOf('?') === -1 && imageUrl.indexOf('_180x180') === -1) {
        imageUrl = imageUrl.replace(/(\.[^.]+)$/, '_180x180$1');
      }

      var cardClass = 'cross-sell-custom__card' + (hasDiscount ? ' cross-sell-custom__card--on-sale' : '');

      return (
        '<div class="' + cardClass + '">' +
        '<img class="cross-sell-custom__card-image" src="' +
        imageUrl +
        '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="65" height="65">' +
        '<div class="cross-sell-custom__card-info">' +
        '<p class="cross-sell-custom__card-title" title="' + product.title.replace(/"/g, '&quot;') + '">' +
        product.title +
        '</p>' +
        metaHTML +
        '</div>' +
        '<button class="cross-sell-custom__add-btn" style="background:' +
        buttonColor +
        ';" data-cross-sell-add="' +
        variant.id +
        '">' +
        buttonText +
        '</button>' +
        '</div>'
      );
    }

    function renderPage(page) {
      var start = page * limit;
      var pageProducts = allProducts.slice(start, start + limit);
      if (pageProducts.length === 0) return;

      carousel.innerHTML = pageProducts.map(buildCard).join('');
      currentPage = page;

      // Wire up variant selectors
      carousel.querySelectorAll('[data-cross-sell-variant]').forEach(function (select) {
        select.addEventListener('change', function () {
          var card = select.closest('.cross-sell-custom__card');
          var btn = card.querySelector('[data-cross-sell-add]');
          var option = select.options[select.selectedIndex];
          var price = parseInt(option.dataset.price, 10);
          var compare = option.dataset.compare ? parseInt(option.dataset.compare, 10) : null;

          btn.dataset.crossSellAdd = option.value;

          var priceEl = card.querySelector('.cross-sell-custom__price');
          var compareEl = card.querySelector('.cross-sell-custom__compare-price');
          if (priceEl) priceEl.textContent = formatPrice(price);

          if (compare && compare > price && showComparePrice) {
            card.classList.add('cross-sell-custom__card--on-sale');
            if (compareEl) {
              compareEl.textContent = formatPrice(compare);
              compareEl.style.display = '';
            }
          } else {
            card.classList.remove('cross-sell-custom__card--on-sale');
            if (compareEl) {
              compareEl.style.display = 'none';
            }
          }
        });
      });
    }

    // Fetch recommendations (request more than limit to allow pagination)
    fetch(
      '/recommendations/products.json?product_id=' +
        productId +
        '&limit=10&intent=complementary'
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        allProducts = data.products || [];
        if (allProducts.length === 0) return;

        renderPage(0);
        container.classList.remove('cross-sell-custom--empty');

        // Navigation buttons
        var prevBtn = container.querySelector('[data-cross-sell-prev]');
        var nextBtn = container.querySelector('[data-cross-sell-next]');
        var totalPages = Math.ceil(allProducts.length / limit);

        // Hide nav if only one page
        if (totalPages <= 1 && prevBtn && nextBtn) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            var newPage = currentPage - 1;
            if (newPage < 0) newPage = totalPages - 1;
            renderPage(newPage);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            var newPage = currentPage + 1;
            if (newPage >= totalPages) newPage = 0;
            renderPage(newPage);
          });
        }
      })
      .catch(function (err) {
        console.error('Cross-sell: recommendations fetch failed', err);
      });

    // Add-to-cart delegation (persists across page renders)
    carousel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cross-sell-add]');
      if (!btn) return;

      var variantId = btn.dataset.crossSellAdd;
      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = textAdded;
          btn.classList.add('cross-sell-custom__add-btn--added');
          document.dispatchEvent(new CustomEvent('cart:updated'));

          setTimeout(function () {
            btn.textContent = buttonText;
            btn.classList.remove('cross-sell-custom__add-btn--added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = textError;
          setTimeout(function () {
            btn.textContent = buttonText;
            btn.disabled = false;
          }, 2000);
        });
    });
  });
})();
